import React from "react";
import AppSelect from "../AppSelect/AppSelect";

/**
 * Choisit le type de données à afficher dans un rapport.
 * @param {object} props
 * @param {string} [props.id]
 * @param {string} [props.value]
 * @param {(id: string, value: string) => void} [props.onValueChanged]
 * @param {boolean} [props.isDarkStyle]
 * @param {object} props.I18n
 * @param {(key: string) => string} props.I18n.get
 */
export default function OperationTypeSelector(props) {
    const {
        id = "type",
        value = "Operations",
        onValueChanged,
        isDarkStyle = false,
        I18n
    } = props;

    return (
        <AppSelect
            id={id}
            label={I18n.get("Select type")}
            allowEmpty={false}
            defaultValue={value}
            onValueChanged={onValueChanged}
            isDarkStyle={isDarkStyle}
            options={[
                "Operations" ,
                "Cash in" ,
                "Inventories" ,
                "Distributions" ,
                "Comparisons"
            ]}
            I18n={I18n}
        />
    );
}
